import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Angulartics2Module } from 'angulartics2';
import { ImageListEditorComponent } from './components/image-list-editor/image-list-editor.component';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        DragDropModule,
        MatIconModule,
        MatTooltipModule,
        Angulartics2Module,
     ],
    declarations: [
        ImageListEditorComponent
    ],
    exports: [
        ImageListEditorComponent
    ]
})
export class ImageListEditorModule {}